"use client"

import styled from "@emotion/styled"
import { extractProperty } from "@eurodrive/utils"
import { Box, Button, Typography } from "@mui/material"
import Link from "next/link"
import { useComparison } from "./contexts/ComparisonContext"
import { sharedColors as colors } from "./theme/colors"

const ComparisonBar = styled(Box)<{ $searchPage?: boolean }>`
  position: fixed;
  bottom: 0;
  left: 120px;
  right: 120px;
  ${(props) =>
    props.$searchPage
      ? `
  margin-left: 264px;`
      : ``}
  z-index: 1000;
  background: ${colors.white};
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  ${(props) => props.theme.breakpoints.down("md")} {
    width: 100%;
    margin: 0;
    right: 0;
    left: 0;
  }
`

const ComparisonContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 10px;
`

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    flex-direction: row;
    justify-content: center;
  }
  gap: 10px;
`

const StyledButton = styled(Button)`
  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    max-width: 249px;
  }
`

interface ComparisonBoxProps {
  comparisonBlock: any
  searchPage?: boolean
}

export default function ComparisonBox({
  searchPage,
  comparisonBlock,
}: ComparisonBoxProps) {
  const twoCarsText = extractProperty(comparisonBlock, "twoCarsText")
  const oneCarText = extractProperty(comparisonBlock, "oneCarText")
  const { count, getComparisonUrl, clearAll } = useComparison()

  // Don't show if less than 2 cars
  if (count < 1) return null

  const comparisonUrl = getComparisonUrl()

  return (
    <ComparisonBar $searchPage={searchPage}>
      <ComparisonContent>
        {count === 1 && oneCarText && (
          <Typography variant="body2">{oneCarText}</Typography>
        )}
        {count === 2 && twoCarsText && (
          <Typography variant="body2">{twoCarsText}</Typography>
        )}
        <ButtonsContainer role="group" aria-label="פעולות השוואת רכבים">
          <StyledButton
            variant="contained"
            size="large"
            sx={{
              backgroundColor: "#194F20",
              "&:hover": {
                backgroundColor: "#0f3316",
              },
            }}
            href={comparisonUrl || "#"}
            LinkComponent={Link}
            disabled={!comparisonUrl}
            aria-label={`להשוואת ${count} הרכבים שנבחרו`}
          >
            להשוואת הרכבים שנבחרו
          </StyledButton>

          <StyledButton
            variant="outlined"
            size="large"
            sx={{
              borderColor: "#194F20",
              color: "#194F20",
              "&:hover": {
                borderColor: "#194F20",
                backgroundColor: "rgba(25, 79, 32, 0.04)",
              },
            }}
            onClick={clearAll}
            aria-label="בטל את כל 3 הרכבים שנבחרו להשוואה"
          >
            ביטול הרכבים שנבחרו
          </StyledButton>
        </ButtonsContainer>
      </ComparisonContent>
    </ComparisonBar>
  )
}
